import { FC } from 'react';
import { Box, useTheme } from '@mui/material';

import { Auth } from './Auth';

export const PrivateLogin: FC = () => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        background: theme.palette.primary.main,
        display: 'flex',
        justifyContent: 'space-around',
        alignItems: 'center',
        width: '100%',
        height: '100vh',
      }}
    >
      <Box
        sx={{
          background: theme.palette.background.paper,
          width: 600,
          padding: theme.spacing(10),
        }}
      >
        <Auth />
      </Box>
    </Box>
  );
};
